import React, { useEffect, useMemo, useState } from 'react'
import { Wrapper, AvatarProfile, Btn } from '../../_components'
import Table from '../../_components/Table'
import Axios from 'axios'
import moment from 'moment'
import { capitalize } from '../../_utils'

const NameField = record => {
    let Name = record.value?.split(" ")

    return (
        <div className="flex flex-col items-start justify-center">
            <AvatarProfile bold label={`${capitalize( Name[ 0 ] )} ${capitalize( Name[ 1 ] )}`}/>
        </div>
    )
}

const ActionField = record => {
    const navigateTo = async ( id, flag) => {
        await localStorage.setItem( "farmerId", id )
        await localStorage.setItem( "farmerName", record?.row.original.name )
        await localStorage.setItem( "farmerCode", record?.row.original.registration_no )
        await localStorage.setItem( "farmerBlockId", record?.row.original.block )
        await localStorage.setItem( "farmerGroup", record?.row.original.ffs_code )
        await localStorage.setItem( "farmerPlot", record?.row.original.plotno )
        
        await localStorage.setItem( "paymentType", flag )
        await localStorage.setItem( "name", "add_payment" )
        return window.location.reload()
    }

    return (
        <div className="flex items-center">
            <Btn handlePress={() => navigateTo( record.value, "water_fees")} label="Water User Fees" color={`#8A3FFC`} />
            <Btn handlePress={() => navigateTo( record.value, "membership")} label="Membership Fees" color={`#3F84FC`} />
            <Btn handlePress={() => navigateTo( record.value, "shares")} label="Buy Shares" color={`#FC413F`} />
        </div>
    )
}

export default function FarmerPayments() {

    const farmerColumns = useMemo(
    () => [
        {
            Header: "#",
            accessor: "fId",
            sortable: false
        },
        {
            Header: "Name",
            accessor: "name",
            sortable: false,
            filterable: false,
            Cell: NameField
        },
        {
            Header: "Scheme",
            accessor: "scheme"
        },
        {
            Header: "Block ID",
            accessor: "block"
        },
        {
            Header: "FFSG No.",
            accessor: "ffs_code"
        },
        {
            Header: "Date Registered",
            accessor: "date"
        },
        {
            Header: "Actions",
            accessor: "id",
            Cell: ActionField
        },
        ]
    )

    const [ records, setRecords ] = useState( [] )
    const [ loading, setLoading ] = useState( true )
    useEffect( () => {
        if( loading ) {
            fetchFarmers()
        }
    },[ loading ])

    const fetchFarmers = async() => {
        try {
            const response = await Axios.get( `https://mis.nec.go.ug/api/auth/farmer` )
            if( response.data ) {
                const results = response.data.records.map( ( farmer ) => {
                    return {
                        name: `${farmer.first_name?.toUpperCase()} ${farmer.last_name?.toUpperCase()}`,
                        block: farmer.block_number,
                        ffs_code: farmer.name,
                        block: farmer.block_id,
                        date: farmer.created_at,
                        id: farmer.id,
                        district: farmer.district,
                        plotno: farmer.plot_number,
                        created_at: moment ( farmer.created_at ).format( "DD MMM, YYYY" ),
                        gender: farmer.gender,
                        registration_no: farmer.reg_number,
                        scheme: farmer.scheme
                    }
                } )
                .filter( item =>  { 
                    return item.scheme?.toLowerCase() === localStorage.getItem( "scheme" ).replace( "_", " " )?.toLowerCase()
                } )
                .sort( ( a, b ) => {
                    return moment( b.created_at ).format( "YYYYMMDD" ) - moment( a.created_at ).format( "YYYYMMDD" )
                } )
            //update the state
            const rows = results.map( ( item, index ) => {
                return { fId: index+1, ...item }
            } ).sort( ( a, b ) => {
                return b.fId > a.fId
            } )
            
            setRecords( rows )
            setLoading( false )
          }
        } catch (error) {
            
        }
    }
    
    return (
    <Wrapper>
     <div className="flex flex-col">
        <h2 className="text-3xl px-2">
            {`Farmer List`}
        </h2>
        {/* <div className="flex items-center justify-end">
            <Btn handlePress={ async () => {
                await localStorage.removeItem( "tag" )
                await localStorage.setItem( "name", "register_farmer" )
                return window.location.reload()
            } } label="" color={`#1DAB47`} />
        </div> */}
        {loading ? (
            <div className="flex items-center justify-center">
                <span className="text-center text-base">
                    {`Loading Farmers...`}
                </span>
            </div>
        ) :
        ( <Table
            label="Registered Farmers"
            columns={farmerColumns}
            data={records}
            hidePagination={false}
        /> ) }
     </div>
    </Wrapper>
  )
}
